import { render } from "./Modal.vue?vue&type=template&id=dad93a5e"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=dad93a5e&lang=css"
script.render = render

export default script